<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>Tạo công việc</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <form [formGroup]="taskFormGroup">
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Tên công việc *</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-label>Tên công việc</mat-label>
                            <input matInput placeholder="Tên công việc" formControlName="name">
                            <mat-error *ngIf="taskFormGroup.controls.name.invalid">Vui lòng nhập tên đề xuất</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Dự án *</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-select required formControlName="project" #singleSelect>
                                <mat-option *ngFor="let project of projects"
                                    [value]="project">
                                    {{project.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Nhóm công việc</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-label>Nhóm công việc</mat-label>
                            <mat-select formControlName="category" #singleSelect>
                                <mat-option>No category</mat-option>
                                <mat-option *ngFor="let category of categories"
                                    [value]="category">
                                    {{category.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Người nhận việc</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-label>Người nhận việc</mat-label>
                            <mat-select formControlName="assignee" #singleSelect>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Tìm kiếm"
                                      noEntriesFoundLabel="Không tìm thấy"
                                      [formControl]="assigneeFilter"></ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let user of filteredUsers | async"
                                    [value]="user">
                                    <div class="d-flex">
                                        <div class="m-2 avatar">
                                            <one-avatar size="32" [imageUrl]="user.avatarUrl"></one-avatar>
                                        </div>
                                        <div class="m-2 info  flex-grow-1">
                                            <div class="name">
                                                {{user.fullName}}
                                            </div>
                                        </div>
                                    </div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Người theo dõi</div>
                    </div>
                    <div class="col-md-8">
                        <one-user-select label="Người theo dõi"
                                    [allUsers]="users"
                                    [oneControl]="taskFormGroup.controls.followers"></one-user-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Ngày bắt đầu</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-label>Ngày bắt đầu</mat-label>
                            <input matInput [matDatepicker]="start_date_picker" formControlName="startDate">
                            <mat-datepicker-toggle matSuffix [for]="start_date_picker"></mat-datepicker-toggle>
                            <mat-datepicker #start_date_picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="label form-label">Thời hạn</div>
                    </div>
                    <div class="col-md-8">
                        <mat-form-field class="full" appearance="outline">
                            <mat-label>Thời hạn</mat-label>
                            <input matInput [matDatepicker]="due_date_picker" formControlName="dueDate">
                            <mat-datepicker-toggle matSuffix [for]="due_date_picker"></mat-datepicker-toggle>
                            <mat-datepicker #due_date_picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
        <button mat-raised-button color="primary" (click)="onCreate()">Tạo công việc</button>
    </mat-dialog-actions>
</div>